module.exports = __webpack_public_path__ + "10_mole.e3a2e329.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/10_mole.png
// module id = ATq1
// module chunks = 0